import { __, prop } from 'ramda';

const PRISMIC_POSITION = {
  'A gauche': 'left',
  'Au centre': 'center',
  'A droite': 'right',
};

export const toPosition = prop(__, PRISMIC_POSITION);
